import { InMemoryProvider } from "@openfeature/react-sdk";
import { FlagsmithClientProvider } from "@openfeature/flagsmith-client-provider";
import {
  FirstSuccessfulStrategy,
  WebMultiProvider,
} from "@openfeature/multi-provider-web";

import flags from "./flags";
import {
  isAutomateTest,
  returnFalseIfRunningViaAutomation,
} from "./automationChecker";

const flagConfig = {
  [flags.APP_MODERNISATION]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant:
      process.env.REACT_APP_FEATURE_FLAG_APP_MODERNISATION || "false",
    contextEvaluator: (context) => {
      if (process.env.REACT_APP_FEATURE_FLAG_APP_MODERNISATION === "true") {
        return returnFalseIfRunningViaAutomation();
      }
    },
  },
  [flags.FORCE_APP_MODE]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant:
      process.env.REACT_APP_FEATURE_FLAG_FORCE_APP_MODE || "false",
  },
  [flags.ENHANCED_SEARCH]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant:
      process.env.REACT_APP_FEATURE_FLAG_ENHANCED_SEARCH || "false",
    contextEvaluator: (context) => {
      if (process.env.REACT_APP_FEATURE_FLAG_ENHANCED_SEARCH === "true") {
        return returnFalseIfRunningViaAutomation();
      }
    },
  },
  [flags.B2C_DISABLE_AUTH]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant: process.env.REACT_APP_B2C_DISABLE_AUTH || "false",
  },
  [flags.ENHANCED_COUNTER]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant: process.env.REACT_APP_FEATURE_ENHANCED_COUNTER || "false",
  },
  [flags.ENHANCED_BROWSER_HISTORY_BUTTON]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant:
      process.env.REACT_APP_FEATURE_FLAG_ENHANCED_BROWSER_HISTORY_BUTTON ||
      "false",
  },
  [flags.WEB_MODERNISATION]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant:
      process.env.REACT_APP_FEATURE_FLAG_WEB_MODERNISATION || "false",
    contextEvaluator: (context) => {
      if (process.env.REACT_APP_FEATURE_FLAG_WEB_MODERNISATION === "true") {
        return returnFalseIfRunningViaAutomation();
      }
      return "false"; // Always return a valid variant
    },
  },
  [flags.CALCULATORS_LEGACY_INTEGRATION]: {
    disabled: false,
    variants: {
      true: true,
      false: false,
    },
    defaultVariant:
      process.env.REACT_APP_FEATURE_FLAG_CALCULATORS_LEGACY_INTEGRATION || "false",
    contextEvaluator: (context) => {
      if (process.env.REACT_APP_FEATURE_FLAG_CALCULATORS_LEGACY_INTEGRATION === "true") {
        return returnFalseIfRunningViaAutomation();
      }
      return "false"; // Always return a valid variant
    },
  },
};

function getOpenFeatureProvider() {
  let providersArray = [];
  const isFlagsmith = process.env.REACT_APP_FLAG_PROVIDER === "flagsmith";

  const provider = isAutomateTest()
    ? new InMemoryProvider(flagConfig)
    : isFlagsmith
      ? new FlagsmithClientProvider({
          environmentID: process.env.REACT_APP_FLAGSMITH_ENV_KEY,
        })
      : new InMemoryProvider(flagConfig);
  providersArray = [{ provider: provider }];

  return new WebMultiProvider(providersArray, new FirstSuccessfulStrategy());
}

export default getOpenFeatureProvider;
